export const publicHashUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

  return publicUrl ? `${publicUrl}/#${normalizedPath}` : `/#${normalizedPath}`;
};
